import { createContext } from 'react';

type IOnboardingContext = {
  showOnboardingProcess: boolean;
  setShowOnboardingProcess: (value: boolean) => void;
  finishedOnboarding: boolean;
  setFinishedOnboarding: (value: boolean) => void;
};

export const OnboardingContext = createContext<IOnboardingContext>({
  showOnboardingProcess: false,
  setShowOnboardingProcess: () => {
    console.warn('setShowOnboardingProcess is called');
  },
  finishedOnboarding: false,
  setFinishedOnboarding: () => {
    console.warn('setFinishedOnboarding is called');
  },
});
